import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import additionalDataFactory from './common/fieldsAdditionalData';
import {
    fieldsPergolaBioClimaticMaterial,
    fieldsPergolaShape,
    fieldPergolaBioclimaticRoof,
    fieldsPergolaDimension,
    fieldsPergolaOptions,
} from './common/fieldsPergola';

const pergolaBioclimaticForm: IForm = {
    formId       : PublishedFormId.PergolaBioclimatic,
    type         : FormTypeId.Pergola,
    thumbnailURL : '/resized-images/forms/pergolaBioclimatic.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.PergolaShape,
        IFormFieldKey.Material,
        IFormFieldKey.PergolaRoof,
        IFormFieldKey.Dimension,
        IFormFieldKey.PergolaOptions,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        pergolaShape   : fieldsPergolaShape,
        material       : fieldsPergolaBioClimaticMaterial,
        pergolaRoof    : fieldPergolaBioclimaticRoof,
        dimension      : fieldsPergolaDimension,
        pergolaOptions : fieldsPergolaOptions,
        additionalData : additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 20000,
            budgetDefaultValue : 6000,
        }),
        contact: fieldsContact,
    },
};

export default pergolaBioclimaticForm;
